import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Translate} from 'react-redux-i18n';
import {AbstractFormComponent, Icon, TextCheckbox} from 'front-onceforall-core';
import * as snackbarsActions from '../../../actions/snackbars';
import userService from '../../../services/user/UserService';
import {captureError} from '../../../utils/log';
import {USER_OPTIONS} from '../../../utils/constant';

const availableOptions = Object.keys(USER_OPTIONS);

export class OptionsForm extends AbstractFormComponent {
  getFormData() {
    const options = {};
    availableOptions.forEach(option => {
      options[option] = this.props.userDetails.options.includes(option);
    });
    return options;
  }

  getFormValidators() {
    return {};
  }

  handleSubmitCallback() {
    const optionsSelected = [];
    Object.entries(this.state.formData).forEach(([optionName, optionValue]) => {
      if (optionValue) {
        optionsSelected.push(optionName);
      }
    });

    userService.updateOptions(this.props.userDetails.id, optionsSelected)
      .then(() => {
        this.props.actions.addSuccess(<Translate value="message.changesSaved"/>);
        this.props.onUpdate();
      })
      .catch(error => {
        this.props.actions.addError(<Translate value="error.generic"/>);
        captureError('Error while saving user options', error);
      })
      .finally(() => this.setState({submitting: false}));
  }

  render() {
    return (
      <form
        className="p-0 d-flex flex-column justify-content-between"
        style={{height: 'calc(100% - 48px)'}}
        onSubmit={this.handleSubmit}
      >
        <div>
          {Object.entries(this.state.formData).map(([optionName, optionValue]) => (
            <TextCheckbox
              key={optionName}
              id={optionName}
              checked={optionValue}
              onChange={this.handleChange(optionName)}
              label={<Translate value={`user.options.${optionName}`}/>}
            />
          ))}
        </div>
        <div className="actions flex-container flex-end">
          <button
            className="large primary flex-container"
            data-id="validateButton"
            type="submit"
            disabled={this.state.submitting}
          >
            <Icon icon={this.state.submitting ? 'loader' : 'check'}/>
            <Translate value="action.confirm"/>
          </button>
        </div>
      </form>
    );
  }
}

OptionsForm.propTypes = {
  actions: PropTypes.object.isRequired,
  userDetails: PropTypes.object.isRequired,
  onUpdate: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...snackbarsActions}, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(OptionsForm);
